import constants from 'src/config/constants.ts'

const notificationCentreMixin = {
  computed: {
    isCalendarEventNotification () {
      return this.notificationTargetType === constants.notificationCentre.sourceTypes.CALENDAR_EVENT
    },
    notificationTargetType () {
      return this.notification?.target_type?.toUpperCase()
    },
    // static list item actions are actions that get triggered by clicking on the list item itself
    staticListItemAction () {
      if (!this.notification?.actions || !Object.keys(this.notification?.actions).length) return
      // return the first action with type 'LIST_ITEM_ACTION' (there should never be more than one)
      return this.notification?.actions[constants.notificationCentre.staticListItemActions.TYPE_KEY]
    }
  }
}

export default notificationCentreMixin
